import { initFilterForm } from '../../assets/js/components/filter-form';

document.querySelectorAll('.section-case-study-filters__form').forEach((form) => {
  const filters = initFilterForm(form, { reset: form.querySelector('.section-case-study-filters__reset') });
  if (!form.hasAttribute('data-manual-submit')) filters.onSelect();
});
